import React from 'react';
import _ from 'lodash';
import { dispatch } from '@rematch/core';
import { Modal, Button } from 'semantic-ui-react';
import CommonTable from '../../../drive/Table/TableLayoutWithoutLocalFilter';
import UserListJson from './UserListJson.json';
export default class UserList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableHeader: UserListJson
        };
        this.handleDropDownItem = this.handleDropDownItem.bind(this);
    }

    addColumn = (newColumns) => {
        if (newColumns) {
            this.setState({ tableHeader: newColumns })
        }
    };

    onQueryChange = (query) => {

        let payload = {
            query: query
        }
        dispatch.platform.getAllAccountUsers(payload)
    };

    handleDropDownItem = (event, type, data) => {
        if (type.text === "Reset Password") {
            dispatch.forgot.forgotAsync(data);
        }
    }

    handleTableComponent = (event, type, data) => {
    }

    closeMessageBox = () => {
        dispatch.forgot.setForgotPwdSuccess(false);
    }

    render() {
        const { forgotSuccess } = this.props;
        return (
            <div style={{ width: "calc(100% - 40px)" }} className="mar_20">
                <CommonTable
                    tableName="Account Users"
                    tableHeader={this.state.tableHeader}
                    listData={this.props.allUsers && this.props.allUsers.data}
                    totalCount={this.props.allUsers && this.props.allUsers.total}
                    searchable={false}
                    loading={this.state.loading}
                    onQueryChange={this.onQueryChange}
                    addColumn={this.addColumn}
                    handleDropDownItem={this.handleDropDownItem}
                    handleTableComponent={this.handleTableComponent}
                    totalCountWithoutSearch={this.props.allUsers && this.props.allUsers.total}
                />
                <Modal size='mini' open={forgotSuccess} onClose={this.closeMessageBox} closeOnDimmerClick={false}>
                    <Modal.Header className='clr-blue'>Reset Password</Modal.Header>
                    <Modal.Content>
                        <p>Password reset link has been sent successfully to the user's email-id.</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className='bg-blue' onClick={this.closeMessageBox}>Ok</Button>
                    </Modal.Actions>
                </Modal>
            </div>

        );
    }
}